export default [
  {
    path: '/activity-20251020-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2025-11-10T23:59:59.000+08:00', title: '秋日集市', id: 3 },
  },
  {
    path: '/activity-20251020-rule',
    component: () => import('./Rule.vue'),
    meta: { expire: '2025-11-10T23:59:59.000+08:00', title: '秋日集市-报名页面', id: 3 },
  },
  {
    path: '/activity-20251020-rule-2',
    component: () => import('./Rule2.vue'),
    meta: { expire: '2025-11-10T23:59:59.000+08:00', title: '秋日集市-规则说明', id: 3 },
  },
]
